<template>
	<div
		class="g-block-body-corner-bracket g-block-body-padding"
		:class="{
			'g-block-body-corner-bracket--edit': editable,
			'is-active': editable && active,
			'g-block-body-corner-bracket--h5': h5,
			'g-block-body-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-body-corner-bracket__inner">
			<span
				class="g-block-body-corner-bracket__corner g-block-body-corner-bracket__corner--tl"
				:style="cornerStyle"
				aria-hidden="true"
			></span>
			<RichTextEditable
				v-if="editable"
				class="g-block-body-corner-bracket__text"
				:model-value="data.content"
				placeholder="请输入正文"
				@update:model-value="onContentUpdate"
				@focus="onWrapClick"
			/>
			<div
				v-else
				class="g-block-body-corner-bracket__text"
				v-html="data.content || ''"
			></div>
			<span
				class="g-block-body-corner-bracket__corner g-block-body-corner-bracket__corner--br"
				:style="cornerStyle"
				aria-hidden="true"
			></span>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { getTitleThemeColor } from '../../../templates.js';
	import { bodyMixin } from '../shared/bodyMixin.js';

	export default {
		name: 'GBlockBodyCornerBracket',
		components: { RichTextEditable },
		mixins: [bodyMixin],
		computed: {
			cornerColor() {
				return getTitleThemeColor(this.data);
			},
			cornerStyle() {
				return { borderColor: this.cornerColor };
			},
		},
	};
</script>

<style scoped lang="less">
	@import '../shared/bodyEditShell.less';

	.g-block-body-corner-bracket {
		.body-block-edit-shell();
	}

	.g-block-body-corner-bracket__inner {
		position: relative;
		padding: 10px 14px;
	}

	.g-block-body-corner-bracket__corner {
		position: absolute;
		width: 18px;
		height: 18px;
		pointer-events: none;

		&--tl {
			top: 0;
			left: 0;
			border-top: 2px solid;
			border-left: 2px solid;
		}

		&--br {
			right: 0;
			bottom: 0;
			border-right: 2px solid;
			border-bottom: 2px solid;
		}
	}

	.g-block-body-corner-bracket__text {
		.body-text-base();
	}

	.g-block-body-corner-bracket--h5 {
		.g-block-body-corner-bracket__inner { padding: 0.2rem 0.28rem; }
		.g-block-body-corner-bracket__corner {
			width: 0.36rem;
			height: 0.36rem;

			&--tl {
				border-top-width: 0.04rem;
				border-left-width: 0.04rem;
			}

			&--br {
				border-right-width: 0.04rem;
				border-bottom-width: 0.04rem;
			}
		}
		.body-text-base--h5(~'.g-block-body-corner-bracket__text');
	}
</style>
